<button
  fd-button
  [fdType]="'transparent'"
  [fdMenu]="true"
  style="z-index: 0"
  [fdPopoverTrigger]="labelPopover"
  class="open-popover-button link-color"
  label="{{ (labels | keyvalue).length | i18nPlural: labelTextMapping }}"
  (click)="$event.stopPropagation()"
></button>
<fd-popover
  #labelPopover
  placement="bottom"
  [noArrow]="true"
  [(isOpen)]="isOpen"
>
  @if (isOpen) {
    <div class="cell-popover">
      <div fd-popover-body-header>
        <div fd-bar [fdCozy]="true" id="popover-bar-header-1">
          <div fd-bar-left>
            <fd-bar-element
              class="header-title"
              i18n="
                XTIT|Title of the Labels
                popover@@organizations.table.labelsPopover.title"
            >
              {{ title }}
            </fd-bar-element>
          </div>
        </div>
      </div>
      <div class="popover-list-values">
        @for (label of labels | keyvalue; track label; let last = $last) {
          <div class="row">
            <div class="key">{{ label.key }}:</div>
            <div class="value">
              <strong>{{ label.value || NO_VALUE_LABEL }}</strong>
            </div>
            @if (!last) {
              <div class="border-line"></div>
            }
          </div>
        }
      </div>
    </div>
  }
</fd-popover>
